module.exports = __webpack_public_path__ + "img/acaki11.8c607bbf.jpg";